import { render } from "./arming-alarm.vue?vue&type=template&id=70e2a7e8&scoped=true&ts=true"
import script from "./arming-alarm.vue?vue&type=script&lang=ts"
export * from "./arming-alarm.vue?vue&type=script&lang=ts"

import "./arming-alarm.vue?vue&type=style&index=0&id=70e2a7e8&scoped=true&lang=css"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e2a7e8"]])

export default __exports__